import { NewTheme } from 'theme/styled';

const LightTheme: NewTheme = {
  palette: {
    white: '#FFF',
    white_90: '#FCFCFD',
    white_70: '#ffffffb3',
    primary: '#1F2C51',
    primary46: '#1f2c5175',
    primary99: '#1f2c5199',
    secondary: '#588AF0',
    secondary7: '#588af012',
    secondarylight: '#5689f00d',
    secondaryLight: '#79a1f3',
    secondaryLightest: '#B4CBFA',
    danger: '#F26464',
    inputBackground: '#EFF0F6',
    placeholder: '#D6D7E3',
    pageBackground: '#E5E5E5',
    boxBackgroundLight: '#F5F5F5',
    boxBackgroundDark: '#EBEBEB',
    lightText: '#97A3BA',
    red: '#EB5757',
    border: '#D8DFED',
    greenLighter: '#ECF5F1',
    greenLight: '#8EC7AC',
    green: '#55BE9B',
    blueLighter: '#EEF3FD',
    success: '#60C08E',
    success10: '#60c08e52',
    warn: '#FAB144',
    warn10: '#EBE0D0',
    error: '#F85858',
    error10: '#f8585863',
    whiteGray: '#D8DBDF',
    lightestGray: '#D6DAEB',
    lightGray: '#BCC1D7',
    middGray: '#a3aec378',
    darkGray: '#9B9BA6',
    purple: '#5888EB',
    gold: '#EBC564',
    deepPurple: '#5D46C2',
    darkBlue: '#01033659',
    middGray2: '#c4c4c4',
    gray10: '#F0F0F3',
    gray20: '#F4F4F5',
    gray40: '#E5E5E9',
    gray60: '#9B9BA6',
    gray80: '#7A7A7A',
  },
  rounded: {
    x1: '4px',
    x2: '8px',
    x3: '12px',
    x4: '16px',
    x5: '20px',
    x6: '24px',
    x7: '28px',
    x8: '32px',
    x9: '36px',
    x10: '40px',
    x25: '100px',
    x50: '50%',
    full: '9999px',
  },
  spacing: {
    inside: {
      x1: '2px',
      x2: '4px',
      x3: '6px',
      x4: '8px',
      x5: '10px',
      x6: '12px',
      x7: '14px',
      x8: '16px',
    },
    x1: '4px',
    x2: '8px',
    x3: '12px',
    x4: '16px',
    x5: '20px',
    x6: '24px',
    x7: '28px',
    x8: '32px',
    x9: '36px',
    x10: '40px',
    x11: '44px',
    x12: '48px',
    x13: '52px',
    x14: '56px',
    x15: '60px',
    x16: '64px',
    x17: '68px',
    x18: '72px',
    x19: '76px',
    x20: '80px',
    x21: '84px',
    x22: '88px',
    x23: '92px',
    x24: '96px',
    x25: '100px',
    x26: '104px',
  },
  zIndex: {
    x1: 1,
    x10: 10,
    x20: 20,
    x50: 50,
    x100: 100,
    x1000: 1000,
    top: 9999,
  },
  media: {
    xl: '1440px',
    lg: '1280px',
    md: '780px',
    sm: '680px',
    xs: '480px',
  },
};

export { LightTheme };
